import { buildChartCsv } from "./formatChartValue";

export default function ChartDownload({ slug, fields = [], entries = [] }) {
  const downloadCsv = () => {
    const csv = buildChartCsv(fields, entries);
    const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `${slug}.csv`;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  return <button type="button" onClick={downloadCsv} disabled={!entries.length} className="btn-secondary disabled:cursor-not-allowed disabled:opacity-50">Download CSV</button>;
}
